export default __webpack_public_path__ + "static/media/teamwork.368b45c9.svg";